class PrimaryFunctions {

	constructor($cookies, store, httpService, mode = "MEMBER_EXPERIENCE") {
		this.base = `${store.state.config.userManagementHost}/securelogins/api/v1`;
		this.endpoints = {
			token: `${this.base}/tokens`,
			users: `${this.base}/users`,
			me: `${this.base}/me`,
			updateAppUserId: `${this.base}/update_app_user_id`,
			passwordReset: `${this.base}/passwords/reset`
		}
		if (mode == "MEMBER_EXPERIENCE") {
			this.applicationId = 5
		} else {
			this.applicationId = 1 //SFC PHP
		}
		this.$cookies = $cookies
		this.store = store
		this.httpService = httpService
	}

	setToken(token) {
		this.$cookies.set("sfc_primary", token, {
			path: "/",
			domain: "savingforcollege.com",
			maxAge: 24 * 60 * 60
		})
	}

	getToken() {
		return this.$cookies.get("sfc_primary")
	}

	deleteToken() {
		this.$cookies.remove("sfc_primary")
	}

	async login(email, password, ciphered = false) {
		let response = undefined

		ciphered = ciphered ? "1" : "0"

		const data = {
			email,
			password,
			app_id: this.applicationId,
			ciphered
		}

		try {
			response = await this.httpService.post(this.endpoints.token, data)
		} catch (error) {
			this.onException("Can't connect to primary app, error in log in", true)
			return false
		}

		if (response.success) {
			this.store.commit('updateLoginStatus', true)
			this.store.commit('updateUserEmail', email)
			this.setToken(response.content.access_token)
			return response.content.access_token
		}

		return false
	}

	async logout() {

		let response = undefined

		const accessToken = this.getToken()

		if (accessToken) {
			const url = `${this.endpoints.token}?access_token=#{access_token}&app_id=${this.applicationId}`

			try {
				response = await this.httpService.delete(url)
			} catch (error) {
				this.onException("Can't connect to primary app, error in log out")
				return false
			}
		}

		this.deleteToken()
		return true
	}

	async getUserByToken(requestedResource = "/") {
		let response = undefined

		const accessToken = this.getToken()

		if (accessToken) {
			const params = {
				accessToken,
				app_id: this.applicationId,
				requested_resource: requestedResource
			};

			try {
				response = await this.httpService.get(this.endpoints.me)
			} catch (error) {
				this.onException("Can't connect to primary app, error in get user")
				return false
			}

			if (response.success) {
				return true
			}
		}
		return false
	}

	async createUser(email, password, username = "", display_name = "") {
		let response = undefined

		const data = {
			app_id: this.applicationId,
			email,
			password,
			username,
			display_name,
			autologin: "true"
		}

		try {
			response = await this.httpService.post(this.endpoints.users, data)
		} catch (error) {
			console.log('error: ', error);
			this.onException("Can't connect to primary app, error in create user", true)
			return {
				created: false,
				message: "Can't connect to primary app, error in create user"
			}
		}

		if (!response.success) {
			return {
				created: false,
				message: response.message
			}
		}

		return {
			created: true,
			message: response.message,
			primaryId: response.content.primary_id
		}
	}

	async updateSourceId(email, source_id) {

		let response = undefined

		const data = {
			app_id: this.applicationId,
			email: email,
			app_user_id: source_id
		}

		try {
			response = await this.httpService.post(this.endpoints.updateAppUserId,data)
		} catch (error) {
			this.onException("Can't connect to primary app, error in create user update id",true)
			return false
		}

		return response.success
	}

	onException(message, stop = false) {
		if (stop) {
			throw message
		}
	}
}

export default PrimaryFunctions
